const selfTrainingReport = {
  self_training_report: `Self Training Report`,
  "ReTrain Overview": `Retrain overview`,
  "Top 10 Tag Names (By Training Counts)": `Top 10 Tag Names (By Training Counts)`,
  "Retrained Models": `Retrained Models`,
  "Tag Name": `Tag Name`,
};
export default selfTrainingReport;
